import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  HospitalProfile,
  HospitalProfilePayload,
} from "@project/types/hospital-profile";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/hospital-profile`;
const SILENT: RequestConfig = { showNotification: false };

class HospitalProfileService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<HospitalProfile>> => {
    return fetchListPage<HospitalProfile>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<HospitalProfile | undefined> => {
    const data = await get<ApiItemResponse<HospitalProfile> | HospitalProfile>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: HospitalProfilePayload
  ): Promise<HospitalProfile | undefined> => {
    const data = await post<
      ApiItemResponse<HospitalProfile> | HospitalProfile,
      HospitalProfilePayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Partial<HospitalProfilePayload>
  ): Promise<HospitalProfile | undefined> => {
    const data = await patch<
      ApiItemResponse<HospitalProfile> | HospitalProfile,
      Partial<HospitalProfilePayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const hospitalProfileService = new HospitalProfileService();
